import React from "react";
import { useStylesAlertModal } from "./style";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "../../assets/images/clear.svg";
import AlertIcon from "../../assets/images/alert-icon.png";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const ConfirmModal = (props) => {
  const classes = useStylesAlertModal();

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light customHeader">
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={() => props.actionEventConfirm("", false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <div className={`${classes.paper} ${"modalBg"}`}>
            <img
              alt="CloseIcon"
              className="ClearModalImg"
              src={CloseIcon}
              onClick={() => props.actionEventConfirm("", false)}
            />
            <div className="alert-icon">
              <img src={AlertIcon} alt="Alert icon" />
              <>
                {/* Condition for some confirmation conditions  */}
                <p className="state_clear">{props.message.slice(0, props.message.indexOf("?") + 1)}</p>
                <p className="state_clear">{props.message.slice(props.message.indexOf("?") + 1)}</p>
                <div className="modal_footer">
                  <button onClick={() => props.actionEventConfirm("", true)} className="btn btn-default senderBtn">{props.i18n.t("Yes")}</button>
                  <button onClick={() => props.actionEventConfirm("", false)} className="btn btn-default cancel_btn">{props.i18n.t("No")}</button>
                </div>
              </>
            </div>
          </div>
        </Fade>
      </Modal>
    </nav>
  );
};

export default withRouter(withTranslation()(ConfirmModal));
